'use strict';

import Report from './report/Report.service'

const state = {}

const actions = {
  ...Report.actions,
}

const mutations = {}

const getters = {}

export default { getters, actions, mutations, state }